// extracted by mini-css-extract-plugin
export var background = "style-module--background--dfbf9";
export var body = "style-module--body--8618c";
export var image = "style-module--image--4f2a4";
export var text = "style-module--text--5e6d0";
export var title = "style-module--title--39d4f";
export var topic = "style-module--topic--ba7be";
export var wrapper = "style-module--wrapper--9cc04";